import { black as blackHex, white as whiteHex } from './config';
import * as hues from './hues';
export * from './hues';
export * from './constants';
export * from './types';
export { hues };
export var black = {
  title: 'Black',
  hex: blackHex
};
export var white = {
  title: 'White',
  hex: whiteHex
};